import { useTranslation } from 'react-i18next';
import { DateNavigator } from '@e2n/ui/v2';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { RefObject } from 'react';

export function YearNavigationHeader({
  kalenderWocheRef,
}: {
  kalenderWocheRef: RefObject<HTMLDivElement | null>;
}) {
  const { t } = useTranslation();
  const {
    store: {
      ui: { year },
      setYear,
    },
  } = useRotationsplanFeatureContext();

  const handleChange = (date: Date) => {
    // Handle today
    if (dayjs(date).isSame(dayjs(), 'day')) {
      if (kalenderWocheRef?.current) {
        kalenderWocheRef.current?.scrollIntoView({
          inline: 'center',
          block: 'nearest',
        });
      }
    }

    setYear(String(date.getFullYear()));
  };

  return (
    <DateNavigator
      granularity="year"
      value={new Date(Number(year), 0, 1)}
      onChange={handleChange}
      todayLabel={t('general.date.today')}
    />
  );
}
